<template>
  <div class="managedefaults">
    <a id="defaults"></a>
    <a id="defaultsDetails"></a>
    <div class="box">
      <div class="title-bar">
        <h3>Details</h3>
        <b-field>
          <b-button
            type="is-text"
            class="has-text-danger"
            @click="resetByKey('details')"
            >Reset to parent</b-button
          >
        </b-field>
      </div>
      <hr style="margin-top: 15px" />
      <form @submit.prevent="boolSubmit" v-on:change="boolSubmit">
        <div class="columns">
          <div class="column">
            <b-field>
              <b-checkbox v-model="defaultsForm.details.random_question_order"
                >Randomise The Question Order</b-checkbox
              >
            </b-field>
            <b-field>
              <b-checkbox v-model="defaultsForm.details.rank_success_driver"
                >Rank Success Driver Importance</b-checkbox
              >
            </b-field>
            <b-field>
              <b-checkbox
                v-model="
                  defaultsForm.details.participants_provide_feedback_givers
                "
                >Participants Provide Feedback Givers</b-checkbox
              >
            </b-field>
          </div>
        </div>
      </form>

      <form @submit.prevent="photoSubmit">
        <div class="columns">
          <div class="column">
            <file-image-upload
              @image-uploaded="photoSubmit"
              name="projectHeader"
              v-model="defaultsForm.details.project_header_file"
              :defaultSrc="defaultsForm.details.project_header"
              :title="'Report Header/Logo'"
            ></file-image-upload>
          </div>
          <div class="column">
            <file-image-upload
              @image-uploaded="photoSubmit"
              name="projectCover"
              v-model="defaultsForm.details.project_cover_file"
              :defaultSrc="defaultsForm.details.project_cover"
              :title="'Report Cover'"
            ></file-image-upload>
          </div>
          <div class="column">
            <file-image-upload
              @image-uploaded="photoSubmit"
              name="projectFooter"
              v-model="defaultsForm.details.project_footer_file"
              :defaultSrc="defaultsForm.details.project_footer"
              :title="'Report Footer'"
            ></file-image-upload>
          </div>
        </div>
      </form>
    </div>

    <div class="floating-button">
      <b-button type="is-info" @click="showVariableCard = !showVariableCard"
        >View Variables</b-button
      >
    </div>

    <b-modal v-model="showVariableCard">
      <div class="card">
        <div class="card-content">
          <h3>
            Below are some of the variables that you can use in the editor
          </h3>
          <hr />
          <ul>
            <!-- prettier-ignore -->
            <li v-pre>{{firstName}} - <b>User's first name</b></li>
            <!-- prettier-ignore -->
            <li v-pre>{{lastName}} - <b>User's last name</b></li>
            <!-- prettier-ignore -->
            <li v-pre>{{email}} - <b>User's email</b></li>
            <!-- prettier-ignore -->
            <li v-pre>{{clientName}} - <b>Client Name</b></li>
            <!-- prettier-ignore -->
            <li v-pre>{{projectName}} - <b>Name of the project</b></li>
            <!-- prettier-ignore -->
            <li v-pre>{{startDate}} - <b>Project Start Date</b></li>
            <li v-pre>
              <!-- prettier-ignore -->
              {{initialEndDate}} - <b>Project Initial End Date</b>
            </li>
            <!-- prettier-ignore -->
            <li v-pre>{{endDate}} - <b>Project Final End Date</b></li>
            <!-- prettier-ignore -->
            <li v-pre>{{scoring}} - <b>List of scores</b></li>
            <!-- prettier-ignore -->
            <li v-pre>{{scoringTable}} - <b>List of scores as a table</b></li>
            <!-- prettier-ignore -->
            <li v-pre>{{linkedParticipants}} - <b>Comma seperated list of participants associated with a feedback giver</b></li>
            <!-- prettier-ignore -->
            <li v-pre>{{firstParticipant}} - <b>Returns the name of the first participant associated with a feedback giver</b></li>
          </ul>
        </div>
      </div>
    </b-modal>

    <div class="box" id="defaultsReports">
      <a id="reports"></a>
      <div class="title-bar">
        <h3>Reports</h3>
        <b-field>
          <b-button
            type="is-text"
            class="has-text-danger"
            @click="resetByKey('reports')"
            >Reset to parent</b-button
          >
        </b-field>
      </div>
      <hr style="margin-top: 15px" />
      <form>
        <div class="columns">
          <div class="column">
            <b-field label="Report Benchmark Heading">
              <b-input
                v-model="defaultsForm.reportBenchmarkName"
                @input="textSubmit('reportBenchmarkName')"
              ></b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Report Group Average Heading">
              <b-input
                v-model="defaultsForm.reportGroupAverageName"
                @input="textSubmit('reportGroupAverageName')"
              ></b-input>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <label for="" class="label">Report Opening Text</label>

            <quill-editor
              @change="textSubmit('reportOpeningText')"
              ref="myQuillEditor"
              v-model="defaultsForm.reportOpeningText"
              :options="quillOptions"
            />
            <label for="" class="label">Report Closing Text</label>
            <quill-editor
              @change="textSubmit('reportClosingText')"
              ref="myQuillEditor"
              v-model="defaultsForm.reportClosingText"
              :options="quillOptions"
            />
          </div>
        </div>
      </form>
    </div>

    <div class="box" id="defaultsWelcomes">
      <a id="welcomes"></a>
      <div class="title-bar">
        <h3>Welcomes</h3>
        <b-field>
          <b-button
            type="is-text"
            class="has-text-danger"
            @click="resetByKey('welcomes')"
            >Reset to parent</b-button
          >
        </b-field>
      </div>
      <hr style="margin-top: 15px" />
      <form>
        <div class="columns">
          <div class="column">
            <label for="" class="label"
              >Welcome Message Upon Starting Feedback (Participant)</label
            >
            <quill-editor
              @change="textSubmit('participantWelcome')"
              ref="myQuillEditor"
              v-model="defaultsForm.participantWelcome"
              :options="quillOptions"
            />
            <label for="" class="label"
              >Welcome Message Upon Starting Feedback (Feedback Giver)</label
            >
            <quill-editor
              @change="textSubmit('feedbackGiverWelcome')"
              ref="myQuillEditor"
              v-model="defaultsForm.feedbackGiverWelcome"
              :options="quillOptions"
            />
            <label for="" class="label"
              >Welcome Information For Entering Own Feedback Givers</label
            >
            <quill-editor
              @change="textSubmit('enterFeedbackGiversWelcome')"
              ref="myQuillEditor"
              v-model="defaultsForm.enterFeedbackGiversWelcome"
              :options="quillOptions"
            />
          </div>
        </div>
      </form>
    </div>

    <div class="box" id="defaultsEmails">
      <a id="emails"></a>
      <div class="title-bar">
        <h3>Welcomes</h3>
        <b-field>
          <b-button
            type="is-text"
            class="has-text-danger"
            @click="resetByKey('emails')"
            >Reset to parent</b-button
          >
        </b-field>
      </div>
      <hr style="margin-top: 15px" />
      <form>
        <div class="columns">
          <div class="column">
            <file-image-upload
              @image-uploaded="photoSubmit"
              name="emailLogo"
              v-model="defaultsForm.email_logo_file"
              :defaultSrc="defaultsForm.email_logo"
              :title="'Email Logo'"
            ></file-image-upload>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Participant Welcome">
              <b-input
                v-model="defaultsForm.participantWelcomeSubject"
                @input="textSubmit('participantWelcomeSubject')"
                maxlength="200"
              ></b-input>
            </b-field>
            <quill-editor
              @change="textSubmit('participantWelcomeBody')"
              ref="myQuillEditor"
              v-model="defaultsForm.participantWelcomeBody"
              :options="quillOptions"
            />
            <b-field label="Participant Chase">
              <b-input
                v-model="defaultsForm.participantChaseSubject"
                @input="textSubmit('participantChaseSubject')"
                maxlength="200"
              ></b-input>
            </b-field>
            <quill-editor
              @change="textSubmit('participantChaseBody')"
              ref="myQuillEditor"
              v-model="defaultsForm.participantChaseBody"
              :options="quillOptions"
            />
            <b-field label="Participant 2nd Chase">
              <b-input
                v-model="defaultsForm.participantSecondChaseSubject"
                @input="textSubmit('participantSecondChaseSubject')"
                maxlength="200"
              ></b-input>
            </b-field>
            <quill-editor
              @change="textSubmit('participantSecondChaseBody')"
              ref="myQuillEditor"
              v-model="defaultsForm.participantSecondChaseBody"
              :options="quillOptions"
            />
            <b-field label="Feedback Giver Welcome">
              <b-input
                v-model="defaultsForm.feedbackGiverWelcomeSubject"
                @input="textSubmit('feedbackGiverWelcomeSubject')"
                maxlength="200"
              ></b-input>
            </b-field>
            <quill-editor
              @change="textSubmit('feedbackGiverWelcomeBody')"
              ref="myQuillEditor"
              v-model="defaultsForm.feedbackGiverWelcomeBody"
              :options="quillOptions"
            />
            <b-field label="Feedback Giver Chase">
              <b-input
                v-model="defaultsForm.feedbackGiverChaseSubject"
                @input="textSubmit('feedbackGiverChaseSubject')"
                maxlength="200"
              ></b-input>
            </b-field>
            <quill-editor
              @change="textSubmit('feedbackGiverChaseBody')"
              ref="myQuillEditor"
              v-model="defaultsForm.feedbackGiverChaseBody"
              :options="quillOptions"
            />
            <b-field label="Feedback Giver 2nd Chase">
              <b-input
                v-model="defaultsForm.feedbackGiverSecondChaseSubject"
                @input="textSubmit('feedbackGiverSecondChaseSubject')"
                maxlength="200"
              ></b-input>
            </b-field>
            <quill-editor
              @change="textSubmit('feedbackGiverSecondChaseBody')"
              ref="myQuillEditor"
              v-model="defaultsForm.feedbackGiverSecondChaseBody"
              :options="quillOptions"
            />
            <b-field label="Feedback Giver Extension">
              <b-input
                v-model="defaultsForm.feedbackGiverExtensionSubject"
                @input="textSubmit('feedbackGiverExtensionSubject')"
                maxlength="200"
              ></b-input>
            </b-field>
            <quill-editor
              @change="textSubmit('feedbackGiverExtensionBody')"
              ref="myQuillEditor"
              v-model="defaultsForm.feedbackGiverExtensionBody"
              :options="quillOptions"
            />
          </div>
        </div>
      </form>
    </div>

    <div class="box" id="defaultsRelationships">
      <a id="relationships"></a>
      <h3>Relationships</h3>
      <hr style="margin-top: 15px" />
      <form
        @submit.prevent="relationshipsSubmit"
        v-on:change="relationshipsSubmit"
      >
        <div class="columns">
          <div class="column">
            <form action="#">
              <div
                class="columns"
                :key="relationship.id"
                v-for="relationship in relationships"
              >
                <div class="column is-flex is-align-items-center">
                  <b-field label="Name">
                    <b-input v-model="relationship.name"></b-input>
                  </b-field>
                </div>
                <div class="column is-flex is-align-items-center">
                  <b-field label="Is Manager">
                    <b-checkbox
                      v-model="relationship.is_manager"
                      :true-value="1"
                      :false-value="0"
                    ></b-checkbox>
                  </b-field>
                </div>
                <div class="column is-flex is-align-items-center">
                  <b-field label="Is Peer">
                    <b-checkbox
                      v-model="relationship.is_peer"
                      :true-value="1"
                      :false-value="0"
                    ></b-checkbox>
                  </b-field>
                </div>
                <div class="column is-flex is-align-items-center">
                  <b-field label="Is Internal">
                    <b-checkbox
                      v-model="relationship.is_internal"
                      :true-value="1"
                      :false-value="0"
                    ></b-checkbox>
                  </b-field>
                </div>
                <div class="column is-flex is-align-items-center">
                  <b-field label="Is External">
                    <b-checkbox
                      v-model="relationship.is_external"
                      :true-value="1"
                      :false-value="0"
                    ></b-checkbox>
                  </b-field>
                </div>
                <div class="column is-flex is-align-items-center">
                  <b-field label="Colour">
                    <v-swatches
                      v-model="relationship.color"
                      label="Colour"
                      :swatches="swatches"
                      @close="relationshipsSubmit"
                    ></v-swatches>
                  </b-field>
                </div>
                <div class="column is-flex is-align-items-center">
                  <div
                    class="icon-container"
                    @click="deleteRelationship(relationship)"
                  >
                    <b-icon
                      pack="fas"
                      icon="trash"
                      type="is-danger"
                      size="is-small"
                    ></b-icon>
                  </div>
                </div>
              </div>
            </form>
            <b-button
              class="button is-primary is-outlined mt-3"
              @click="addRelationship"
            >
              Add
            </b-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import VSwatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.css';
import FileImageUpload from '../../Components/Management/FileImageUpload';

// BEGIN quill editor
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
//import Quill from 'quill'
//import QuillEasyTable from 'quill-easy-table';
// END quill editor

// Quill.register({
//   'modules/easy-table': QuillEasyTable
// }, true);

class Relationship {
  constructor(args) {
    this.id = args.id ?? '';
    this.name = args.name ?? '';
    this.is_manager = args.is_manager ?? 0;
    this.is_peer = args.is_peer ?? 0;
    this.is_internal = args.is_internal ?? 1;
    this.is_external = args.is_external ?? 0;
    this.color = args.color ?? '#cc0001';
  }
}

export default {
  components: {
    VSwatches,
    FileImageUpload,
    quillEditor,
  },
  props: {
    defaults: { type: Object },
    entity: { type: Object },
    entityType: { type: String },
    relationships: { Type: Array },
  },
  data() {
    return {
      defaultsForm: {
        details: {
          random_question_order:
            parseInt(this.defaults.randomQuestionOrder.value) == 1,
          rank_success_driver:
            parseInt(this.defaults.rankSuccessDriver.value) == 1,
          participants_provide_feedback_givers:
            parseInt(this.defaults.participantsProvideFeedbackGivers.value) ==
            1,
          project_header: this.defaults.projectHeader.value,
          project_header_file: null,
          project_cover: this.defaults.projectCover.value,
          project_cover_file: null,
          project_footer: this.defaults.projectFooter.value,
          project_footer_file: null,
        },
        reportOpeningText: this.defaults.reportOpeningText.value,
        reportClosingText: this.defaults.reportClosingText.value,
        reportBenchmarkName: this.defaults.reportBenchmarkName.value,
        reportGroupAverageName: this.defaults.reportGroupAverageName.value,
        participantWelcome: this.defaults.participantWelcome.value,
        feedbackGiverWelcome: this.defaults.feedbackGiverWelcome.value,
        enterFeedbackGiversWelcome:
          this.defaults.enterFeedbackGiversWelcome.value,
        email_logo: this.defaults.emailLogo?.value ?? '',
        email_logo_file: null,
        participantWelcomeSubject:
          this.defaults.participantWelcomeSubject.value,
        participantWelcomeBody: this.defaults.participantWelcomeBody.value,
        participantChaseSubject: this.defaults.participantChaseSubject.value,
        participantChaseBody: this.defaults.participantChaseBody.value,
        participantSecondChaseSubject:
          this.defaults.participantSecondChaseSubject.value,
        participantSecondChaseBody:
          this.defaults.participantSecondChaseBody.value,
        feedbackGiverWelcomeSubject:
          this.defaults.feedbackGiverWelcomeSubject.value,
        feedbackGiverWelcomeBody: this.defaults.feedbackGiverWelcomeBody.value,
        feedbackGiverChaseSubject:
          this.defaults.feedbackGiverChaseSubject.value,
        feedbackGiverChaseBody: this.defaults.feedbackGiverChaseBody.value,
        feedbackGiverSecondChaseSubject:
          this.defaults.feedbackGiverSecondChaseSubject.value,
        feedbackGiverSecondChaseBody:
          this.defaults.feedbackGiverSecondChaseBody.value,
        feedbackGiverExtensionSubject:
          this.defaults.feedbackGiverExtensionSubject.value,
        feedbackGiverExtensionBody:
          this.defaults.feedbackGiverExtensionBody.value,
      },
      isSending: false,
      canSend: true,
      hasMobileCards: true,
      swatches: [
        '#3B3838',
        '#FF0000',
        '#0033CC',
        '#00B0F0',
        '#FFC000',
        '#7030A0',
        '#bfff00',
        '#ff007f',
      ],
      quillOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],

              [{ list: 'ordered' }, { list: 'bullet' }],

              [{ header: [1, 2, 3, 4, 5, false] }],

              ['clean'],

              ['image', 'link'],

              [
                {
                  color: [
                    '#F00',
                    '#339933',
                    '#003300',
                    '#0b1a75',
                    '#000',
                    '#595959',
                    '#FFF',
                  ],
                },
              ],
            ],
          },
        },
      },
      showVariableCard: false,
    };
  },
  methods: {
    boolSubmit() {
      const data = {
        entity_id: this.entity.unique_id,
        entityType: this.entityType,
        form: {
          randomQuestionOrder: this.defaultsForm.details.random_question_order
            ? 1
            : 0,
          rankSuccessDriver: this.defaultsForm.details.rank_success_driver
            ? 1
            : 0,
          participantsProvideFeedbackGivers: this.defaultsForm.details
            .participants_provide_feedback_givers
            ? 1
            : 0,
        },
      };
      this.$inertia.patch(route('defaults.entityUpdate.index'), data, {
        preserveScroll: true,
        onStart: () => (this.defaultsForm.isSending = true),
        onFinish: () => {
          if (Object.keys(this.errors).length) {
            this.$buefy.toast.open({
              message: 'There was an error updating',
              type: 'is-danger',
              position: 'is-top',
            });
          } else {
            this.$buefy.toast.open({
              message: 'Information updated',
              type: 'is-success',
              position: 'is-top',
            });
          }
          this.form.isSending = false;
        },
        onError: () => {},
      });
    },
    photoSubmit(args) {
      console.log('doing the args');
      console.dir(args);
      const data = new FormData();
      data.append(args.name, args.file);
      data.append('entityType', this.entityType);
      data.append('entity_id', this.entity.unique_id);
      this.$inertia.post(route('defaults.entityUpdate.imageUpdate'), data, {
        preserveScroll: true,
      });
    },
    textSubmit(name) {
      if (this.canSend) {
        this.canSend = false;
        var self = this;
        setTimeout(function () {
          self.$inertia.patch(
            self.route('defaults.entityUpdate.index'),
            {
              entity_id: self.entity.unique_id,
              entityType: self.entityType,
              form: {
                [name]: self.defaultsForm[name],
              },
            },
            {
              preserveScroll: true,
            }
          );
          self.canSend = true;
        }, 1500);
      }
    },
    addRelationship: function () {
      const name = `Relationship ${this.relationships.length + 1}`;
      this.relationships.push(new Relationship({ name }));
    },
    deleteRelationship: function (relationship) {
      this.$inertia.patch(
        route('defaults.entityUpdate.deleteRelationships'),
        relationship,
        {
          preserveScroll: true,
          preserveState: false,
        }
      );
    },
    relationshipsSubmit() {
      const data = {
        entity_id: this.entity.unique_id,
        entityType: this.entityType,
        form: this.relationships,
      };
      this.$inertia.patch(route('defaults.entityUpdate.relationships'), data, {
        preserveScroll: true,
        onFinish: () => {
          if (Object.keys(this.$page.props.errors).length) {
            this.$buefy.toast.open({
              message: 'There was an error updating the relationships',
              type: 'is-danger',
              position: 'is-top',
            });
          } else {
            this.$buefy.toast.open({
              message: 'Relationship information updated',
              type: 'is-success',
              position: 'is-top',
            });
          }
          this.form.isSending = false;
        },
      });
    },
    resetByKey(defaultGroup) {
      const keys = this.resolveGroupByKey(defaultGroup);
      this.$inertia.post(
        route('defaults.entityReset'),
        {
          defaults: keys,
          entity_id: this.entity.unique_id,
          entity_type: this.entityType,
        },
        {
          preserveScroll: true,
          onSuccess: () => {
            window.location.reload();
          },
        }
      );
    },
    resolveGroupByKey(group) {
      switch (group) {
        case 'details':
          return _.mapKeys(this.defaultsForm[group], (v, k) => _.camelCase(k));
        case 'reports':
          return _.pickBy(this.defaultsForm, (v, k) =>
            _.startsWith(k, 'report')
          );
        case 'welcomes':
          return _.pickBy(this.defaultsForm, (v, k) =>
            _.endsWith(k, 'Welcome')
          );
        case 'emails':
          return {
            emailLogo: this.defaultsForm.email_logo,
            participantWelcomeSubject:
              this.defaultsForm.participantWelcomeSubject,
            participantWelcomeBody: this.defaultsForm.participantWelcomeBody,
            participantChaseSubject: this.defaultsForm.participantChaseSubject,
            participantChaseBody: this.defaultsForm.participantChaseBody,
            participantSecondChaseSubject:
              this.defaultsForm.participantSecondChaseSubject,
            participantSecondChaseBody:
              this.defaultsForm.participantSecondChaseBody,
            feedbackGiverWelcomeSubject:
              this.defaultsForm.feedbackGiverWelcomeSubject,
            feedbackGiverWelcomeBody:
              this.defaultsForm.feedbackGiverWelcomeBody,
            feedbackGiverChaseSubject:
              this.defaultsForm.feedbackGiverChaseSubject,
            feedbackGiverChaseBody: this.defaultsForm.feedbackGiverChaseBody,
            feedbackGiverSecondChaseSubject:
              this.defaultsForm.feedbackGiverSecondChaseSubject,
            feedbackGiverSecondChaseBody:
              this.defaultsForm.feedbackGiverSecondChaseBody,
            feedbackGiverExtensionSubject:
              this.defaultsForm.feedbackGiverExtensionSubject,
            feedbackGiverExtensionBody:
              this.defaultsForm.feedbackGiverExtensionBody,
          };
        default:
          return [];
      }
    },
  },
};
</script>
